import React, { useState } from "react";
import {
  Box,
  Button,
  Avatar,
  Typography,
  Tabs,
  Tab,
  Container,
  Divider,
  FormControl,
  InputLabel,
  TextField,
  useMediaQuery, // Import the useMediaQuery hook
  Theme,
} from "@mui/material";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import LargeCard from "../../../Shared-ui/SharedComponents/Cards/LargeCard";
import UserProfileForm from "../../Components/UserProfileForm";
import PassResetForm from "../../Components/PassResetForm";
import TabPanel, { a11yProps } from "../../../Shared-ui/SharedComponents/TabPanel";
import variables from "../../../assets/styles/variables.module.scss"
import UserSubscription from "../../Components/UserSubscription";
import { useLocation } from "react-router-dom";
import UserActivity from "../../Components/Activity";

interface MyComponentProps {

}


const UserProfile: React.FC<MyComponentProps> = () => {

  const location = useLocation();

  // Split the pathname into parts to generate breadcrumbs
  const pathParts = location.pathname.split('/').filter(Boolean);

  // Vertical Tabs
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  // Media query to check screen size
  const isSmallDevice = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Breadcrumb data={[{name:"Profile", path:""}]}/>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmallDevice ? "column" : "row", // Change layout dynamically
            height: "100%",
            gap: 4,
          }}
        >
          <Tabs
            orientation={isSmallDevice ? "horizontal" : "vertical"} // Adjust orientation dynamically
            variant="scrollable"
            value={tabValue}
            onChange={handleTabChange}
            aria-label="Dynamic Tabs"
            textColor="primary"
            indicatorColor="primary"
            sx={{
              borderRight: isSmallDevice ? 0 : 1, // Remove border on small devices
              borderBottom: isSmallDevice ? 1 : 0, // Add bottom border on small devices
              borderColor: "divider",
              minWidth: isSmallDevice ? "100%" : "200px", // Adjust width
            }}
          >
            <Tab
              label="Profile"
              {...a11yProps(0)}
              sx={{
                textTransform: "capitalize",
                alignItems: isSmallDevice ? "center" : "flex-start",
                p: 0,
                
              }}
            />
            <Tab
              label="Password"
              {...a11yProps(1)}
              sx={{
                textTransform: "capitalize",
                alignItems: isSmallDevice ? "center" : "flex-start",
                p: 0,
              }}
              id="tab-1"
              aria-controls="tabpanel-1"
            />
            <Tab
              label="Subscription"
              {...a11yProps(2)}
              sx={{
                textTransform: "capitalize",
                alignItems: isSmallDevice ? "center" : "flex-start",
                p: 0,
              }}
            />
            {/* <Tab
              label="Activity"
              {...a11yProps(3)}
              sx={{
                textTransform: "capitalize",
                alignItems: isSmallDevice ? "center" : "flex-start",
                p: 0,
              }}
            /> */}
          </Tabs>
          <Box
            sx={{
              width: "100%",
            }}
          >
            {/* use as "div" intead od "tabpanel" else show mui exception  */}

            {/* User Profile section */}

            <TabPanel value={tabValue} index={0}>
              <UserProfileForm />
            </TabPanel>

            {/* User Password reset section */}
            <TabPanel value={tabValue} index={1}>
              <PassResetForm />
            </TabPanel>

            {/* User Subscription section */}
            <TabPanel value={tabValue} index={2}>
              <UserSubscription />
            </TabPanel>

            {/* User Activity log section */}
            {/* <TabPanel value={tabValue} index={3}> */}
              {/* <UserActivity/> */}
            {/* </TabPanel> */}
            {/* ////////////////////// */}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default UserProfile;
